import {Controller} from "@hotwired/stimulus"
import {get} from "@rails/request.js";

// Connects to data-controller="load-more"
export default class extends Controller {

  static values = {
    url: String,
    nextPage: String,
  }

   loadMore() {
    const url = new URL(this.urlValue);
    url.searchParams.set("page", event.currentTarget.dataset.nextPage);

     get(url.href, {
      responseKind: "turbo-stream",
    });
  }
}
